import { AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import { RiEdit2Fill } from 'react-icons/ri';
import { SpokenLanguage } from '../../types/languages';
import SkillBadge from '../CommonComps/Badges/SkillBadge';
import UpdateSpecializedLanguagesModal from '../CommonComps/Modals/UpdateSpecializedLanguagesModal';
import SectionHeader from '../CommonComps/Titles/SectionHeader';

const SpecializedLanguages = ({
  languages,
}: {
  languages: Array<SpokenLanguage> | undefined;
}) => {
  // integration of react hooks here
  const [showEditModal, setShowEditModal] = useState<boolean>(false);

  // rendering specialized languages component here
  return (
    <div className='xl:col-span-2 2xl:col-span-1 p-5 rounded-xl shadow-academia-sm'>
      <SectionHeader
        headerText='Specialized languages'
        extraElement={
          <button
            title='Edit Specialized Languages'
            onClick={() => setShowEditModal((state) => !state)}
            className='text-base-white bg-base-cyan border border-base-cyan p-1 rounded-md hover:opacity-70 active:scale-95 duration-300'
          >
            <RiEdit2Fill className='size-5' />
          </button>
        }
      />

      {languages?.length ? (
        <div className='flex flex-wrap items-center gap-3'>
          {languages.map((language) => (
            <SkillBadge
              key={language.id}
              badgeLabel={language.name}
              color='#4CB9E7'
            />
          ))}
        </div>
      ) : (
        <p className='text-center font-medium text-base-red'>
          No Language Added!!
        </p>
      )}

      <AnimatePresence initial={false} mode='wait' onExitComplete={() => null}>
        {showEditModal && (
          <UpdateSpecializedLanguagesModal
            languages={languages}
            handleModalClose={() => setShowEditModal(false)}
          />
        )}
      </AnimatePresence>
    </div>
  );
};

export default SpecializedLanguages;
